<template>
    <div>
        <!-- 轮播图 -->
        <div class="slide-box">
            <Slide/>
        </div>
        <!-- 轮播图 -->
        
         <!-- TEAMS -->
        <div class="teams-row">
            <div class="row">
                <h1>{{$t('capabilities.trustedBy')}}</h1>
                <ul class="teams-img-list">
                    <li v-for="(item,index) in teamsImg" :key="index">
                        <img class="img-responsive" :src="item.url" alt="">
                    </li>
                </ul>
            </div>
        </div>

        <div class="cap-row">
            <div class="col-sm-4 cap-img" >
                <img class="img-responsive" src="../../assets/images/Capabilities_img.png" alt="">                
            </div>
            <div class="col-sm-5 cap-title">
                <h1>{{$t('capabilities.ourCapabilities.title')}}</h1>
                <p>{{$t('capabilities.ourCapabilities.introText')}}<router-link to="/CoreCompetencies">{{$t('aboutUs.here')}}</router-link></p>
            </div>
            <div class="col-sm-3 cap-btn">
                <router-link class="btn" to="/ContactUs">{{$t('capabilities.ourCapabilities.fullList')}}</router-link>
            </div>
        </div>

        <!-- INDUSTRIES -->
        <div class="indus-row">
            <div class="row injectMold-row">
                <div class="col-sm-6 indus-img">
                    <img class="img-responsive" src="../../assets/images/pexels-thisisengineering-3862615.png" alt="">
                </div>
                <div class="col-sm-6 indus-text">
                    <h1>{{$t('capabilities.engineeringConsulting.title')}}</h1>
                    <p>{{$t('capabilities.engineeringConsulting.introText')}}</p>
                    <router-link class="btn" to="/EngineeringConsulting">{{$t('common.learnMore')}}</router-link>
                </div>
            </div>
            <div class="row metal-row">
                <div class="col-sm-6 indus-img show">
                    <img class="img-responsive" src="../../assets/images/CERTIFICATIONS_img.png" alt="">
                </div>
                <div class="col-sm-6 indus-text">
                    <h1>{{$t('capabilities.certifications.title')}}</h1>
                    <p>{{$t('capabilities.certifications.introText')}}</p>
                    <router-link class="btn" to="/Certifications">{{$t('common.learnMore')}}</router-link>
                </div>
                <div class="col-sm-6 indus-img hide">
                    <img class="img-responsive" src="../../assets/images/CERTIFICATIONS_img.png" alt="">
                </div>
            </div>
            <div class="row finishing-row">
                <div class="col-sm-6 indus-img">
                    <img class="img-responsive" src="../../assets/images/science-in-hd-ooNO0LlxZRM-unsplash.png" alt="">
                </div>
                <div class="col-sm-6 indus-text">
                    <h1>{{$t('capabilities.massProduction.title')}}</h1>
                    <p>{{$t('capabilities.massProduction.introText')}}</p>
                </div>
            </div>
            <div class="row metal-row">
                <div class="col-sm-6 indus-img show" style="background:#29AAE1">
                    <img class="img-responsive" src="../../assets/images/Screenshot 2021-05-31 183245.png" alt="">
                </div>
                <div class="col-sm-6 indus-text">
                    <h1>{{$t('capabilities.automation.title')}}</h1>
                    <p>{{$t('capabilities.automation.introText')}}</p>
                </div>
                <div class="col-sm-6 indus-img hide" style="background:#29AAE1">
                    <img class="img-responsive" src="../../assets/images/Screenshot 2021-05-31 183245.png" alt="">
                </div>
            </div>
        </div>

        <!-- <div class="column-row">
            <img src="../../assets/images/pexels-thisisengineering-3862632.png" alt="">
        </div>
        <div class="row eng-row">
            <h2>ENGINEERING & CONSULTING</h2>
            <p>Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat</p>
            <router-link to="EngineeringConsulting" class="btn-list">Learn More</router-link>
        </div>

        <div class="row">
            <ul class="pic-list">
                <li v-for="(item,index) in capabilitiesList" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <h1>{{item.title}}</h1>
                    <p>{{item.text}}</p>
                    <router-link :to="item.toLink" class="btn-list">Learn More</router-link>
                </li>
            </ul>
        </div> -->
        
    </div>
</template>

<script>
    import Slide from '../../components/Slide/Slide' 
    export default {
        data() {
            return {
                capabilitiesList:'',
                teamsImg:[
                    {url:require('../../assets/images/ProgressMark_logo.png')},
                    {url:require('../../assets/images/sony_logo_black.png')},
                    {url:require('../../assets/images/Nvidia-logo_black.png')},
                    {url:require('../../assets/images/Dell_logo_black.png')},
                    {url:require('../../assets/images/inter_logo_black.png')},
                    {url:require('../../assets/images/lenovo-logo-black.png')},
                    {url:require('../../assets/images/asus-logo-black.png')}
                ]
            }
        },
        components:{
            Slide
        },
        methods:{
            // getCapabilitiesList(){
            //     this.$api.capabilities.capabilitiesList().then(res=>{
            //         this.capabilitiesList = res.data.result
            //         console.log(res.data.result)
            //     }).catch(
            //         (error) => {
            //             console.log(error)
            //         }
            //     )
            // }
        },
        mounted(){
            // this.getCapabilitiesList();
        }
    }
</script>

<style scoped>
    .cap-row{
        background: #091932;
        width:100%;
        overflow: hidden;
    }
    .cap-btn{
        margin-top: 27rem;
    }
    .cap-img{
        padding-top:5rem;
        padding-left: 5rem;
        padding-bottom: 5rem;
    }
    .cap-title{
        padding-left: 0;
    }
    .cap-img ul{
        float: right;
        margin-top: 12rem;
        padding-right: 3rem;
    }
    .cap-img ul li{
        margin-bottom: 4rem;
    }
    .cap-img ul li h2{
        font-size: 3.6rem;
        font-weight: 700;
        text-align: left;
    }
    .cap-img ul li span{
        display: block;
        text-align: left;
        font-size: 1.6rem;
        font-weight: 700;
    }
    .cap-row .btn{
        width:25rem;
    }
    .cap-row h1{
        text-align: left;
        margin-bottom: 4rem;
        font-size: 4.8rem;
        font-weight: 700;
        color: #fff;
        margin-top: 4rem;
        margin-right: 4rem;
    }
    .cap-row p{
        text-align: left;
        width:auto;
        font-size: 1.6rem;
        color:#fff !important;
        margin-top: 6rem;
        margin-right: 4rem;
    }
    .cap-row p a{
        color:#fff !important;
    }
    .cap-row img{
        max-width: 100%;
        height: auto;
    }

    .indus-row .row{
        margin-bottom: 0;
        margin-top: 0;
        max-width: 100%;
    }
    .indus-row .mater-row{
        padding-right: 100px;
    }
    .indus-row h1{
        text-align: left;
        font-size:4.8rem;
        font-weight: 700;
        margin-bottom: 2rem;
        color: #00457A;
    }
    .indus-row p{
        text-align: left;
        width: 100%;
        margin-bottom: 2rem;
    }
    .indus-text{
        padding:10rem;
        padding-bottom: 0;
    }
    .metal-row .indus-text,.finishing-row .indus-text{
        padding-top: 25rem;
    }
    .indus-img{
        background: #00457A;
        padding: 10rem;
    }
    .metal-row .indus-img{
        background: #00457A;
    }
    .finishing-row .indus-img{
        background:#091932;
    }
    .injectMold-row .indus-img{
        background:#29AAE1;
    }
    .indus-list{
        overflow: hidden;
    }
    .indus-list li{
        float:left;
        width:33.3333333%;
        padding:0 1rem;
        margin-top: 1rem;
    }
    .indus-list li img{
        max-width: 100%;
        height:auto;
        display: block;
        margin:0 auto;
    }
    .indus-list li h2{
        margin-top: 2rem;
        font-weight: 700;
        font-size: 1.4rem;
    }
    .indus-list li p{
        width:100%;
        font-size: 1.4rem;
        height:6rem;
        line-height: 2rem;
        overflow: hidden;
        margin:2rem 0;
        text-align: left;
    }

    .column-row{
        margin-bottom: 4rem;
    }
    .column-row img{
        max-width: 100%;
        height: auto;
    }
    .eng-row h2{
        text-align: center;
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 2rem;
    }
    .eng-row p{
        width: 50%;
        margin:0 auto;
        margin-bottom: 2rem;
    }
    .teams-row{
        width:100%;
        background:#fff;
    }
    .teams-row .row{
        margin-top: 0;
        margin-bottom: 0;
    }
    .teams-row h1{
        font-size: 2rem;
        font-weight: 700;
        margin:4rem 0;
    }
    .teams-row ul{
        margin-bottom: 4rem;
        display: table;
    }
    .teams-row ul li{
        display: table-cell;
        text-align: center;
        width: 1%;
        padding: 1rem;
    }
    .teams-row ul li img{
        max-width:100%;
        height: auto;
    }
    .show{
        display: none !important;
    }
    .hide{
        display: block !important;
    }
    @media (min-width: 768px) and (max-width: 1024px){
        .cap-row h1{
            font-size: 2rem;
            margin:2rem;
        }
        .cap-row p{
            font-size: 1.4rem;
            line-height: 2rem;
            height: 10rem;
            overflow: hidden;
            margin-left: 2rem;
            margin-top: 2rem;
        }
        .cap-row h1{
            margin-top: 4rem;
        }
        .cap-btn{
            margin-top: 20rem;
        }
        .cap-img ul{
            margin-top: 4rem;
        }
        .cap-img ul li{
            margin-bottom: 2rem;
        }
        .cap-img ul li h2{
            font-size: 1.6rem;
            text-align: right;
        }
        .cap-img ul li span{
            text-align: right;
            font-size: 1.2rem;
        }
        .cap-row .btn{
            width:15rem;
            height:3.6rem;
            font-size: 1.2rem;
            line-height: 3.6rem;
        }
        .indus-img,.indus-text{
            padding:4rem;
        }
        .indus-text{
            padding-bottom: 2rem;
        }
        .indus-row h1{
            font-size: 2.4rem;
        }
        .metal-row .indus-text, .finishing-row .indus-text{
            padding-top: 4rem;
        }
    }
    @media (max-width: 767px){
        .cap-row{
            padding-bottom: 1rem;
        }
        .cap-title{
            height: auto;
        }
        .cap-row h1{
            text-align: center;
            margin: 0;
            font-size: 1.2rem;
            padding-top: 1rem;
        }
        .cap-row p{
            text-align: left;
            font-size: .7rem;
            margin-bottom: 1rem;
            padding:0;
            margin:0;
            margin-top: 1rem;
            margin-left: 1rem;
            padding-bottom: 1rem;
        }
        .cap-btn{
            margin-top: 1rem;
            margin-bottom: 1rem;
        }
        .cap-img{
            padding-top:1rem;
            padding-left: 1rem;
            padding-bottom: 1rem;
        }
        .cap-img ul{
            width:60%;
            float:right;
            margin-top:3rem;
            padding-right: 0;
        }
        .cap-img ul li{
            margin-bottom: 1rem;
            overflow: hidden;
        }
        .cap-row .btn{
            width:8rem;
            height:2rem;
            line-height: 2rem;
            font-size: .6rem;
            margin:0 auto;
        }
        .cap-img ul li h2{
            font-size: .8rem;
            text-align: right;
        }
        .cap-img ul li span{
            font-size: 0.6rem;
            text-align: right;
        }

        .indus-row .injectMold-row{
            margin-bottom: 0 !important;
        }
        .indus-row h1{
            font-size: 1.2rem;
            margin-bottom:2rem ;
            text-align: center;
        }
        .indus-text{
            padding: 40px 15px;
            padding-top: 2rem;
            overflow: hidden;
        }
        .indus-text p{
            width: 100%;
            text-align: center;
            padding: 0;
        }
        .indus-img{
            padding:1rem;
        }

        .column-row{
            margin-bottom: 1rem;
        }
        .eng-row h2{
            text-align: center;
            font-size: 1.2rem;
            margin-bottom: 1rem;
        }
        .eng-row p{
            width: auto;
            padding:0 1rem;
            margin-bottom: 1rem;
        }
        .teams-row h1{
            font-size: 0.8rem;
            margin:1rem 0;
        }
        .teams-row ul{
            margin-bottom: 1rem;
        }
        .teams-row ul li{
            padding:0.2rem
        }
        .metal-row .indus-text,.finishing-row .indus-text{
            padding-top: 2rem;
        }
        .show{
            display: block !important;
        }
        .hide{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Services/Capabilities.vue